import axios, { CancelTokenSource } from 'axios';
import request from '../config/http';
import { IVacancyDto } from '../models/Vacancy/IVacancyDto';
import { ApiResponseGetVacancies } from '../models/Vacancy/ApiResponseGetVacancies';
import { ApiResponseGetVacancyById } from '../models/Vacancy/ApiResponseGetVacancyById';
import { IVacancyDictionariesDto } from '../models/Dictionaries/IVacancyDictionariesDto';
import { IVacancyResponse } from './type';

const basicUrl = '/api/v1/vacancies';
const basicSecureUrl = '/api/v1/secure/vacancies';

let cancelToken: CancelTokenSource | undefined;

const getVacancyById = (id: any): Promise<ApiResponseGetVacancyById<IVacancyDto>> =>
    request.get(basicUrl + '/' + id);

const getVacancies = (
    params?: Record<string, unknown>,
): Promise<ApiResponseGetVacancies<Array<IVacancyDto>>> => {
    if (cancelToken) {
        cancelToken?.cancel('Операция отменена из-за нового запроса');
    }
    cancelToken = axios.CancelToken.source();
    return request.get(basicUrl + '/list', { params, cancelToken: cancelToken.token });
};
const getVacanciesReferences = (): Promise<ApiResponseGetVacancyById<IVacancyDictionariesDto>> =>
    request.get(basicUrl + '/dictionaries');

const getRespondVacancy = () => request.get(basicSecureUrl + '/respond');

const respondVacancy = (formData: FormData) => request.put(basicSecureUrl + '/respond', formData);

const responseById = (id: string): Promise<ApiResponseGetVacancyById<IVacancyResponse>> =>
    request.get(basicSecureUrl + '/respond/' + id);

const checkResponse = (vacancyId: number): Promise<ApiResponseGetVacancyById<IVacancyResponse>> =>
    request.get(`${basicSecureUrl}/check/${vacancyId}`);

const vacancyFavorite = () => request.get(basicUrl + '/favorite');

const setVacancyFavorite = (params?: Record<string, unknown>) =>
    request.put(`${basicUrl}/favorite`, {}, { params });

export const vacancyManager = {
    getVacancies,
    getVacancyById,
    respondVacancy,
    checkResponse,
    responseById,
    vacancyFavorite,
    setVacancyFavorite,
    getVacanciesReferences,
    getRespondVacancy,
};
